var productCardMarkup =
  `<div class="swym-wishlist-grid">
		{{#products}}
	<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div>
    <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
    <p class="swym-title">
      {{dt}}
    </p>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
    </div>
		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="btn">
			{{#isInCart}}Added to Cart{{/isInCart}}{{^isInCart}}Add to Cart{{/isInCart}}
		</button>
    </a>
      {{/products}}
	</div>`;

	var productCardMarkupViewer =
  `<div class="swym-wishlist-grid">
		{{#products}}
	<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor">
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div>
    <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
    <p class="swym-title">
      {{dt}}
    </p>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
    </div>
		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="btn">
			{{#isInCart}}Added to Cart{{/isInCart}}{{^isInCart}}Add to Cart{{/isInCart}}
		</button>
    </a>
      {{/products}}
	</div>`;


function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {

	const urlParams = new URLSearchParams(window.location.search);
	const listKey = urlParams.get('hkey');

	// render the items if its a shared link
	if(listKey && listKey != null) {

		let listConfig = {
			"lid": listKey ,
		};


let onListedSuccess = function(listContents) {

	let fromCustomer = listContents[0]?.cby;

	if(document.querySelector(`h1[data-dynamic-share]`)){
		let originalTitle = document.querySelector(`h1[data-dynamic-share]`).innerHTML;
		let updatedTitle = `${originalTitle} for ${fromCustomer}`;
		document.querySelector(`h1[data-dynamic-share]`).innerHTML = updatedTitle;
	}


	var wishlistContentsContainer = document.getElementById("wishlist-items-container");

	var formattedWishlistedProducts = listContents.map(function(p) {
		p = SwymUtils.formatProductPrice(p);
		p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
		p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
		return p;
	});
	var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkupViewer, {
		products: formattedWishlistedProducts
	});
	if(wishlistContentsContainer){
		wishlistContentsContainer.innerHTML = productCardsMarkup;
		attachClickListeners();
	} else{
		console.log("Container not found, Wishlist Page element not found");
	}
	const wishlistCount = document.querySelector('.site-header__wishlist__count');
	if(wishlistCount){
		if(listContents.length > 0){
			wishlistCount.classList.remove('is-hidden');
		} else {
			wishlistCount.classList.add('is-hidden');
		}
		wishlistCount.innerHTML = listContents.length;
	}
	
}

let onListedError = function(error) {
  console.log("Error fetching List Contents", error);
}

swat.fetchListCtx(listConfig, onListedSuccess, onListedError);

	// if not, its the logged in customer
	} else {

			// Get wishlist items
	swat.fetch(function(products) {
		// console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
      console.log("Container not found, Wishlist Page element not found");
		}
    const wishlistCount = document.querySelector('.site-header__wishlist__count');
    if(wishlistCount){
      if(products.length > 0){
        wishlistCount.classList.remove('is-hidden');
      } else {
        wishlistCount.classList.add('is-hidden');
      }
      wishlistCount.innerHTML = products.length;
    }

	});


	let mainID = '';

	let onLinkCreationSuccess = (link, lid) => {
		// console.log("Successfully Generated Link ", link, lid);
		if(document.querySelector('#wishlisht-generated-url-inject')) {
			document.querySelector('#wishlisht-generated-url-inject').innerHTML = `<a href="${link}" target="_blank">${link}</a>`;
		}
	}
	let onLinkCreationError = (error) => {
		console.log("Error while generating the link", error)
	}

	let onPublicSuccess = (response) => {
		// console.log("Successfully Marked List Public ", response.lid);
		swat.generateSharedListURL(mainID, onLinkCreationSuccess, onLinkCreationError);
	}
	let onPublicError = (error) => {
		console.log("Error while marking the list public", error)
	}

	let onFetchSuccess = function(lists) {
		if(lists.length >= 1){
			mainID = lists[0]?.lid
			// console.log(lists[0])

			swat.markListPublic(mainID, onPublicSuccess, onPublicError);
		}
	}
	let onFetchError = function(error) {
		console.log("Error while fetching all Lists", error);
	}


	if(document.querySelector('#share-wishlist-action')) {
		document.querySelector('#share-wishlist-action').classList.remove('visually-hidden');
		document.querySelector('#share-wishlist-action').addEventListener('click', function(){

			swat.fetchLists({
				callbackFn: onFetchSuccess,
				errorFn: onFetchError
			});

			if(document.querySelector('#wishlist-sharer-popup')) {
				document.querySelector('#wishlist-sharer-popup').classList.add('open');
			}
		})
	}
	}

}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	
	var _count = parseInt(document.querySelector('.site-header__cart__count').innerHTML);

	// console.log('counter', _count);

	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		// console.log("Successfully added product to cart.", c);

		if(document.querySelector('.site-header__cart__count').innerHTML == 0 ){
			document.querySelector('.site-header__cart__count').innerHTML = 1;
			document.querySelector('.site-header__cart__count').classList.remove('is-hidden');
		} else {
			document.querySelector('.site-header__cart__count').innerHTML = _count + 1;
		}
		
	}, function(e) {
		// console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

document.addEventListener('DOMContentLoaded', function() {
	if(document.querySelector('#wishlist-sharer-closer')) {
		document.querySelector('#wishlist-sharer-closer').addEventListener('click', function(){
			if(document.querySelector('#wishlist-sharer-popup')) {
				document.querySelector('#wishlist-sharer-popup').classList.remove('open');
			}
		})
	}
})